import React from "react";
import { Typography } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const BottomSection = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/policy");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "50px auto",
        maxWidth: "900px",
        padding: "0 20px",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "100px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {/* First Navigation Item - List your property with us */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            cursor: "pointer",
          }}
          onClick={handleNavigate}
        >
          {/* Text */}
          <Text
            style={{
              color: "white",
              fontWeight: "500",
              fontFamily: "Inknut Antiqua",
              fontSize: "22px",
            }}
          >
            List your property with us
          </Text>

          {/* Arrow Circle */}
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "1.5px solid #fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "0.3s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "transparent")
            }
          >
            <RightOutlined style={{ fontSize: "16px", color: "#fff" }} />
          </div>
        </div>

        {/* Second Navigation Item - Checkout what buyers want */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/listed-property")}
        >
          {/* Text */}
          <Text
            style={{
              color: "white",
              fontWeight: "500",
              fontFamily: "Inknut Antiqua",
              fontSize: "22px",
            }}
          >
            Checkout what buyers want
          </Text>

          {/* Arrow Circle */}
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "1.5px solid #fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "0.3s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "transparent")
            }
          >
            <RightOutlined style={{ fontSize: "16px", color: "#fff" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomSection;
